(function () {
  'use strict';

  var countdownInterval = null;

  function startCountdown() {
    var el = document.querySelector('[data-elyone-countdown]');
    if (!el) {
      if (countdownInterval) { clearInterval(countdownInterval); countdownInterval = null; }
      return;
    }
    var minutes = parseInt(el.getAttribute('data-duration'), 10) || 15;
    var storageKey = 'elyoneCartTimerEnd';
    var now = Date.now();
    var end = parseInt(sessionStorage.getItem(storageKey), 10);
    if (!end || isNaN(end) || end <= now) {
      end = now + minutes * 60 * 1000;
      sessionStorage.setItem(storageKey, String(end));
    }

    if (countdownInterval) clearInterval(countdownInterval);

    function tick() {
      var valueEl = document.querySelector('[data-elyone-countdown-value]');
      var remaining = end - Date.now();
      if (!valueEl) { clearInterval(countdownInterval); countdownInterval = null; return; }
      if (remaining <= 0) {
        valueEl.textContent = '00:00';
        sessionStorage.removeItem(storageKey);
        clearInterval(countdownInterval);
        countdownInterval = null;
        return;
      }
      var m = Math.floor(remaining / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      valueEl.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }
    tick();
    countdownInterval = setInterval(tick, 1000);
  }

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function cartPageUrl() {
    var root = shopifyRoot();
    return root.charAt(root.length - 1) === '/' ? root + 'cart' : root + '/cart';
  }

  function updateCartBubble(itemCount) {
    document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
      el.textContent = itemCount < 100 ? String(itemCount) : '';
      el.classList.toggle('hidden', itemCount === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', itemCount === 0);
    });
  }

  function revealVisible() {
    var page = document.querySelector('.elyone-cart-page');
    if (!page) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
      }, { threshold: 0.1 });
      page.querySelectorAll('.elyone-reveal:not(.is-visible)').forEach(function (el) { io.observe(el); });
    } else {
      page.querySelectorAll('.elyone-reveal').forEach(function (el) { el.classList.add('is-visible'); });
    }
    startCountdown();
  }

  /* Fetch the real, current /cart page HTML and swap in just our container.
     This sidesteps any Section Rendering API quirks entirely. */
  function refreshCartPage() {
    var current = document.querySelector('.elyone-cart-page');
    if (current) current.style.opacity = '0.45';
    return fetch(cartPageUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.elyone-cart-page');
        var live = document.querySelector('.elyone-cart-page');
        if (fresh && live) {
          live.replaceWith(fresh);
        } else if (live) {
          live.style.opacity = '1';
        }
        revealVisible();
      })
      .catch(function () {
        if (current) current.style.opacity = '1';
      });
  }

  function changeLine(line, quantity) {
    return fetch(shopifyRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBubble(cart.item_count);
        return refreshCartPage();
      });
  }

  function addBundle(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    var original = button.textContent;
    button.disabled = true;
    button.textContent = '…';
    fetch(shopifyRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (err) { return Promise.reject(err); }); }
        return fetch(shopifyRoot() + 'cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBubble(cart.item_count);
        return refreshCartPage();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Réessayer';
        setTimeout(function () { button.textContent = original; }, 2000);
      });
  }

  /* Event delegation on document: works even after the cart container is
     replaced, or if the page was reached through a client-side navigation. */
  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-elyone-qty-increase]');
    var decBtn = e.target.closest('[data-elyone-qty-decrease]');
    var removeBtn = e.target.closest('[data-elyone-remove]');
    var bundleBtn = e.target.closest('[data-elyone-add-bundle]');

    if (incBtn) {
      var incItem = incBtn.closest('[data-elyone-cart-line]');
      if (!incItem) return;
      var incQtyEl = incItem.querySelector('[data-elyone-qty-value]');
      var incQty = parseInt(incQtyEl.textContent, 10) + 1;
      incBtn.disabled = true;
      changeLine(parseInt(incItem.getAttribute('data-elyone-cart-line'), 10), incQty);
    } else if (decBtn) {
      var decItem = decBtn.closest('[data-elyone-cart-line]');
      if (!decItem) return;
      var decQtyEl = decItem.querySelector('[data-elyone-qty-value]');
      var decQty = parseInt(decQtyEl.textContent, 10) - 1;
      decBtn.disabled = true;
      changeLine(parseInt(decItem.getAttribute('data-elyone-cart-line'), 10), decQty);
    } else if (removeBtn) {
      var removeItem = removeBtn.closest('[data-elyone-cart-line]');
      if (!removeItem) return;
      removeItem.style.opacity = '0.3';
      removeBtn.disabled = true;
      changeLine(parseInt(removeItem.getAttribute('data-elyone-cart-line'), 10), 0);
    } else if (bundleBtn) {
      addBundle(bundleBtn);
    }
  });

  revealVisible();
  startCountdown();
})();
